import * as angular from 'angular';
import messagesDirective from './messages-directive';
import messagesService from './messages-service';

export default angular.module('dataforvalter.messages', [])
    .directive('messages', messagesDirective)
    .service('messages', messagesService)
    .name;
